import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'angular-web-storage';
import { CookieService } from "ngx-cookie-service";
import { ToastrManager } from 'ng6-toastr-notifications';
import { DataService } from '../../../data.service';
declare var $;

@Component({
  selector: 'app-capture',
  templateUrl: './capture.component.html',
  styleUrls: ['./capture.component.scss'],
})
export class CaptureComponent implements OnInit {
  token;
  cookieValue = this.session.get("sessionID");
  plan = [];
  constructor(
    private server: DataService,
    private routte: ActivatedRoute,
    private toastr: ToastrManager,
    private cookieService: CookieService,
    public session: SessionStorageService
  ) {
    this.token = this.session.get('sessionID');
    if ($(".toggled")) {
      $("#tog").click();
    }

    $('.app-wrap').removeClass('sidebar-toggled');
  }

  ngOnInit(): void {
       let dep = {
      val: this.cookieValue,
      key: "dep",
    };
    this.server.Api(dep).subscribe(
      (res) => {
        if (res["code"] == 1) {
          this.plan = res["plan"];

          console.log(this.plan);
        }
      },
      () => {},
      () => {}
    );
  }

  Hash(x: NgForm) {
    let med = {
      hash: x.value.hash,
      currency: x.value.currency,
      token: this.token,
      key: 'hash',
    };
    this.server.Api(med).subscribe((res) => {
      if (res['code'] == 1) {
        this.toastr.successToastr('hash updated');
      }
      if (res['code'] == 2) {
        this.toastr.warningToastr('Failed to update');
      }
    });
  }
}
